
export const CONFIG_FALLBACK = {
    "landscapeWizardAvailability": {
        "staging": false,
        "canary": true,
        "prod": false
    },
    "privateCloud": false,
    "hideOpscurity": false,
    "aiAssistant": {
        "enabled": false
    },
    "stagingParameters": [{
        "wizardName": "Dev",
        "displayName": "Dev",
        "infix": "dev"
    }, {
        "wizardName": "Test",
        "displayName": "Test",
        "infix": ""
    }],
    "spfiEndpoint": "http://spc-spfi-adapter.spc-spfi-adapter.svc.cluster.local:4008/v1"
};
